import timeline from "../images/timeline.png";

export const WeddingTimeline = () => {
  return (
    <section className="mx-auto w-full max-w-md px-3 py-10 sm:px-0 sm:py-14">
      <img src={timeline} alt="События" />
    </section>
  );
};
